import { AppBar, Box, Container, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../i18n/LanguageSwitcher"; // Import the switcher

const navItems = [
  { key: "services", path: "/services" },
  { key: "talent", path: "/fan-access" },
  { key: "dancing", path: "/dancing-with-the-stars", special: true },
  { key: "partners", path: "/partners" },
  { key: "contact", path: "/contact" },
];

export default function NavbarDesktop({ mode = "dark" }) {
  const isLight = mode === "light";
  const { t } = useTranslation("nav");

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        backgroundColor: isLight ? "transparent" : "#fff",
        color: "text.primary",
        display: { xs: "none", md: "block" },
        py: 3,
      }}
    >
      <Container maxWidth="xl">
        <Box
          display="grid"
          gridTemplateColumns="auto 1fr auto"
          alignItems="center"
        >
          {/* Logo */}
          <NavLink to="/" style={{ textDecoration: "none" }}>
            <Typography
              sx={{
                fontFamily: "Playfair Display",
                letterSpacing: "0.25em",
                fontSize: "0.9rem",
                color: isLight ? "wheat" : "",
                cursor: "pointer",
              }}
            >
              HELVIETA
            </Typography>
          </NavLink>

          {/* Navigation */}
          <Box
            display="flex"
            justifyContent="center"
            gap={{ md: 4, lg: 6, xl: 8 }}
          >
            {navItems.map((item) => (
              <NavItem
                key={item.key}
                label={t(`items.${item.key}`)}
                to={item.path} // route fixed
                special={item.special}
                isLight={isLight}
              />
            ))}
          </Box>

          {/* Language Switcher */}
          <Box display="flex" justifyContent="flex-end">
            <LanguageSwitcher isLight={isLight} />
          </Box>
        </Box>
      </Container>
    </AppBar>
  );
}

function NavItem({ label, to, special, isLight }) {
  return (
    <NavLink to={to} style={{ textDecoration: "none" }}>
      {({ isActive }) => (
        <motion.div initial="rest" animate="rest" whileHover="hover">
          <Typography
            sx={{
              fontSize: "0.75rem",
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              fontFamily: special ? "Playfair Display" : "Inter",
              fontStyle: special ? "italic" : "normal",
              position: "relative",
              color: isLight ? "#FFFFFF" : "#111111",
              transition: "color 0.3s ease",
              pb: 0.5,
            }}
          >
            {label}

            <motion.span
              variants={{
                rest: { width: isActive ? "100%" : 0 },
                hover: { width: "100%" },
              }}
              transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
              style={{
                position: "absolute",
                left: 0,
                bottom: 0,
                height: 1,
                backgroundColor: special ? "#C6A972" : "#0B0B0B",
              }}
            />
          </Typography>
        </motion.div>
      )}
    </NavLink>
  );
}
